module.exports = __webpack_public_path__ + "img/service-tab-img4.b4d46e9f.png";